export class EscalatedNoteResolutionCommand {
    verificationId: string;
    resolutionNote: string;

    constructor(verificationId: string, resolutionNote: string) {
        this.verificationId = verificationId;
        this.resolutionNote = resolutionNote;
    }
}
